import { useQuery } from "react-query";
import { articleSearch } from "../../Service/ArticleService";
import { queryKeys } from "./queryKeys";

function fetchArticleSearchSuggestions(searchTerm, product) {
  const pathParams = {
    searchTerm,
    ...(product && { product }),
  };
  return articleSearch(searchTerm, pathParams).then((result) => {
    const raw =
      result?.data?.data?.articles ?? result?.data?.articles ?? [];
    return Array.isArray(raw) ? raw : [];
  });
}

/**
 * Keyword search for dropdown suggestions (GET article/search).
 * Call with debounced search term; enable when searchTerm.length >= 2.
 */
export function useArticleSearchSuggestions(searchTerm, product) {
  const enabled = typeof searchTerm === "string" && searchTerm.trim().length >= 2;

  return useQuery(
    queryKeys.articleSearchSuggestions(searchTerm, product),
    () => fetchArticleSearchSuggestions(searchTerm, product),
    {
      enabled,
      staleTime: 60 * 1000,
    }
  );
}
